module.exports = __webpack_public_path__ + "static/img/CONG.ccb7b2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/motion/CONG.png
// module id = xDZ/
// module chunks = 2